import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { ContractAdministration } from "./ContractAdministration/ContractAdministration";
import { Introduction } from "./Introduction/Introduction";
import { ManualWelcomePage } from "./ManualWelcomePage/ManualWelcomePage";
import { ProcurementPlanning } from "./ProcurementPlanning/ProcurementPlanning";
import { Requisition } from "./Requisition/Requisition";
import { Sourcing } from "./Sourcing/Sourcing";
import { VendorManagement } from "./VendorManagement/VendorManagement";
import { HyperLink } from "../Popup/HyperLink/HyperLink";
import { Icon } from "@iconify/react";

export const Manual = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdChildActiveTab = query.get("thirdChildActiveTab");

    if (!activeTab) {
      navigate(`/dedicated/magp/manual?activeTab=manualWelcomePage`, {
        replace: true,
      });
    } else {
      if (activeTab == "introduction") {
        navigate(`/dedicated/magp/manual?activeTab=introduction&subActiveTab=${subActiveTab ?? "preface"}`, {
          replace: true,
        });
      }

      if (activeTab == "procurementPlanning") {
        navigate(
          `/dedicated/magp/manual?activeTab=procurementPlanning&subActiveTab=${
            subActiveTab ?? "businessCase"
          }&thirdChildActiveTab=${thirdChildActiveTab ?? "businessCaseOverview"}`,
          {
            replace: true,
          }
        );
      }

      if (activeTab == "requisition") {
        navigate(
          `/dedicated/magp/manual?activeTab=requisition&subActiveTab=${
            subActiveTab ?? "purchaseRequisition"
          }&thirdChildActiveTab=${thirdChildActiveTab ?? "purchaseRequisitionOverview"}`,
          {
            replace: true,
          }
        );
      }
      if (activeTab == "sourcing") {
        navigate(
          `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=${
            subActiveTab ?? "tenderManagement"
          }&thirdChildActiveTab=${thirdChildActiveTab ?? "tenderManagementOverview"}`,
          {
            replace: true,
          }
        );
      }
      if (activeTab == "contractAdministration") {
        navigate(
          `/dedicated/magp/manual?activeTab=contractAdministration&subActiveTab=${
            subActiveTab ?? "contractManagementImplementation"
          }&thirdChildActiveTab=${thirdChildActiveTab ?? "contractManagementImplementationOverview"}`,
          {
            replace: true,
          }
        );
      }
      if (activeTab === "vendorManagement") {
        navigate(
          `/dedicated/magp/manual?activeTab=vendorManagement&subActiveTab=${
            subActiveTab ?? "vendorRegistration"
          }&thirdChildActiveTab=${thirdChildActiveTab ?? "vendorRegistrationOverview"}`,
          {
            replace: true,
          }
        );
      }
    }
  }, [query.get("activeTab")]);

  const items = [
    {
      label: "Manual Welcome Page",
      key: "manualWelcomePage",
      children: <ManualWelcomePage />,
    },
    // {
    //   label: "Manual Landing Page",
    //   key: "manualLandingPage",
    //   children: <ManualLandingPage />,
    // },
    {
      label: "Introduction",
      key: "introduction",
      children: <Introduction />,
    },
    {
      label: "Procurement Planning",
      key: "procurementPlanning",
      children: <ProcurementPlanning />,
    },
    {
      label: "Requisition",
      key: "requisition",
      children: <Requisition />,
    },
    {
      label: "Sourcing",
      key: "sourcing",
      children: <Sourcing />,
    },
    {
      label: "Contract Administration ",
      key: "contractAdministration",
      children: <ContractAdministration />,
    },
    {
      label: "Vendor Management",
      key: "vendorManagement",
      children: <VendorManagement />,
    },
    {
      label: "Hyperlink Popup",
      key: "hyperLinkPopUp",
      children: <HyperLink />,
    },
  ];

  return (
    <ContentWrapper title={"Manual"}
    actionItems={ query.get('activeTab')==='hyperLinkPopUp' && (
      <Button
        onClick={() => {
          navigate("/dedicated/magp/manual/hyperlink/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
      >
        Add New HyperLink
      </Button>
    )
    }>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
